import { usePostReagentApi, usePutReagentApi } from 'api/reagent'
import { Flex } from 'components/shared/flex'
import { ChoiceField, InputField, SelectField } from 'components/shared/input'
import { GlobalStateContext } from 'contexts/global_state_context'
import { useContext, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { Form, useEffectSkipFirst, useForm } from 'utils/hooks'
import { ApiError } from 'utils/network/api_hooks'
import { Reagent, ReagentForm, REAGENT_KIND_SELECT_ITEM } from 'entities/reagent'

export type FormViewProps = {
    form: Form<ReagentForm>
    apiError: ApiError
}

const FormView = ({ form, apiError }: FormViewProps) => {
    return (
        <>
            <Flex>
                <InputField form={form} attr="name" apiError={apiError} label="試薬名" required />
            </Flex>
            <Flex>
                <ChoiceField form={form} attr="preservation" apiError={apiError} label="保存方法" required tableName="reagent" />
                <SelectField form={form} attr="kind" apiError={apiError} label="種別" selectItems={REAGENT_KIND_SELECT_ITEM} includeBlank />
            </Flex>
        </>
    )
}

type NewReagentFormProps = {
    onComplete?: () => void
}

export const NewReagentForm = (props: NewReagentFormProps): JSX.Element => {
    const globalState = useContext(GlobalStateContext)
    const api = usePostReagentApi()
    const form = useForm<ReagentForm>({})
    const [show, setShow] = useState<boolean>(false)

    const handleUpdate = () => {
        api.execute(form)
    }

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
        if (api.isSuccess()) {
            if (props.onComplete) {
                setShow(false)
                props.onComplete()
            }
        }
    }, [api.loading])

    const handleClose = () => {
        setShow(false)
    }

    return (
        <>
            <Button
                variant="success"
                onClick={() => {
                    setShow(true)
                }}
            >
                新規登録
            </Button>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>試薬の登録</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <>
                        <FormView form={form} apiError={api.apiError} />
                    </>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        閉じる
                    </Button>
                    <Button variant="success" onClick={handleUpdate}>
                        登録
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
type EditReagentFormProps = {
    reagent: Reagent
    show: boolean
    onClose: () => void
    onComplete?: () => void
}

export const EditReagentForm = (props: EditReagentFormProps): JSX.Element => {
    const globalState = useContext(GlobalStateContext)
    const api = usePutReagentApi()
    const form = useForm<ReagentForm>(props.reagent)

    useEffectSkipFirst(() => {
        form.set(props.reagent)
    }, [props.reagent])

    const handleUpdate = () => {
        api.execute(form)
    }

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
        if (api.isSuccess()) {
            if (props.onComplete) {
                props.onComplete()
            }
        }
    }, [api.loading])

    return (
        <Modal show={props.show} onHide={props.onClose}>
            <Modal.Header closeButton>
                <Modal.Title>試薬の編集</Modal.Title>
            </Modal.Header>
            <Modal.Body>{form.object.id && <FormView form={form} apiError={api.apiError} />}</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.onClose}>
                    閉じる
                </Button>
                <Button variant="success" onClick={handleUpdate}>
                    更新
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
